module.exports = __webpack_public_path__ + "img/huiwei.e83068da.png";